import React from 'react';

const Location = () => {
  return (
    <svg className="map" viewBox="0 0 24 24">
      <path className="st0" d="M21,10c0,7-9,13-9,13s-9-6-9-13c0-5,4-9,9-9S21,5,21,10z" />
      <circle className="st0" cx="12" cy="10" r="3" />
    </svg>
  );
};

export default Location;